import React from "react";

export const ThreadListSkeleton: React.FC = () => (
  <ul className="divide-y divide-border/60">
    {Array.from({ length: 6 }).map((_, i) => (
      <li key={i} className="flex gap-3 px-3 py-3 animate-pulse">
        <div className="h-11 w-11 rounded-full bg-muted shrink-0" />
        <div className="flex-1 space-y-2 min-w-0 pt-1">
          <div className="h-3.5 w-2/3 rounded bg-muted" />
          <div className="h-3 w-full rounded bg-muted/80" />
        </div>
      </li>
    ))}
  </ul>
);
